import React, { useEffect, cloneElement } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import { useLocation } from "react-router-dom"

import userStore from "userStore"
import Permission from "./Permission"
import Actions from "./Actions/Actions"
import Loading from "./Loading"

import { ErrorBoundary } from "react-error-boundary"

import "./layout.scss"

function ErrorFallback({ error, componentStack }) {
  return (
    <div className="py-3">
      <p className="mb-1 fw-bold">Ha ocurrido un error!</p>
      <pre className="text-danger mb-0">{error.message}</pre>
      <pre className="text-danger mb-0">{componentStack}</pre>
    </div>
  )
}

const Layout = ({
  components,
  title,
  save,
  print,
  formik,
  loading,
  permissionBy,
  buttonText,
  solicitud = {},
}) => {
  const modificacion = userStore(state => state.modificacion)
  const permisos = userStore(state => state.permisos)

  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname.includes("/busqueda") || pathname.includes("/alta-titular")) {
      userStore.setState({ idTitular: "" })
    }
  }, [pathname])

  return (
    <div
      className="page-content"
      style={{ minHeight: pathname.includes("/busqueda") ? "80vh" : "60vh" }}
    >
      <div className="mx-2 mx-md-4 mt-n1">
        <Row>
          <Col xs="12" className="position-relative">
            <div>
              <Permission
                {...{ permisos, pathname, permissionBy }}
                RenderError={() => (
                  <>
                    <Actions
                      {...{ save, print, modificacion, formik, loading, title }}
                    />
                    <Card>
                      <CardBody>
                        No contas con los permisos necesarios..
                      </CardBody>
                    </Card>
                  </>
                )}
              >
                <div className="d-flex flex-column">
                  <Actions
                    {...{
                      save,
                      print,
                      modificacion,
                      formik,
                      loading,
                      solicitud,
                      buttonText,
                      title,
                    }}
                  />
                  <div className="mt-1">
                    {components.map(
                      (item, id) =>
                        item.component && (
                          <Card key={id}>
                            <CardBody
                              className={
                                item.component.props?.expandable
                                  ? "py-none"
                                  : ""
                              }
                            >
                              <Loading loading={loading}>
                                <ErrorBoundary
                                  FallbackComponent={ErrorFallback}
                                  onReset={() => {
                                    // reset the state of your app so the error doesn't happen again
                                  }}
                                >
                                  {cloneElement(item.component, {
                                    modificacion,
                                  })}
                                </ErrorBoundary>
                              </Loading>
                            </CardBody>
                          </Card>
                        ),
                    )}
                  </div>
                </div>
              </Permission>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Layout
